module.exports = __webpack_public_path__ + "media/images/flags/4x3/lby-f93c267c9bce51287e8ddb2b26c6c8a6.svg";